import React, { useEffect, useState } from "react";
import "./styles.scss";
import assets from "../../Assets";
import {
  notifySuccess,
  notifyError,
} from "../../Services/Utils/toastNotification";
import Button from "../../Components/Button";
import InputBox from "../../Components/InputBox";
import ErrorMessage from "Components/ErrorMessage";
import { validateInput } from "Services/Utils/validateInput";
import { useDispatch } from "react-redux";
import { deleteAccountRequest } from "../../Redux/Slices/authSlice";


const DeleteAccount = () => {

  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const handleValidation = () => {
    let validationErrors = {};

    // Handle mobile validation separately with country code
    const emailError = validateInput("email", email);
    if (emailError.email) {
      validationErrors.email = emailError.email;
    }

    setErrors(validationErrors);
    return validationErrors;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const validationErrors = handleValidation();
    if (Object.keys(validationErrors).length === 0) {
      console.log(email);
       dispatch(
         deleteAccountRequest({
           data: {email},
           callBack: (data) => {
             notifySuccess("Sent a Confirmation Email to your email address.");
           },
         })
       );
    }
  };

  return (
    <div className="deletePageContainer">
    <div className="deletePage">
        <div className="logoContainer">
            <img src={assets.Icons.kgLogo} className="appLogo" alt="" />
        </div>
        
        <h1 className="DeleteHeader">Deleting Account</h1>
        
        <p className="DeleteDescription">
            Deleting your account will remove all your information from our
            databases. This Cannot be undone.
        </p>

        <form onSubmit={onSubmit} style={{width: '100%'}}>
            <div className="deleteInputContainer">
                <div style={{flex: 1}}>
                    <div className="deleteInput">
                        To Confirm this, enter "Email Address"
                    </div>
                    <InputBox
                        inputStyle={{ width: "100%", border: "1px solid black" }}
                        name="email"
                        value={email}
                        placeholder=""
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <ErrorMessage message={errors.email} />
                    <br></br>
                    <Button
                    forForm={true}
                    title="Delete Account"
                    className="ml-3 px-3"
                    buttonStyle={{
                        height: "56px",
                        width: "150px",
                        padding: "0px 10px",
                        background: "#FC0000",
                        border: "none",
                    }}
                />                
                </div>
            </div>
        </form>
    </div>
</div>
  );
};

export default DeleteAccount;
